import { SituacaoAso } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type GenerateAsoFilters = {
  protocolo: string
  /** Primeiro nome do paciente (busca parcial). */
  paciente: string
  situacao?: IOption<SituacaoAso>
  estado?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<GenerateAsoFilters>({
  protocolo: '',
  paciente: '',
  situacao: undefined,
  estado: undefined,
})
